/* Dolci Vita - deter casual image lifting and reverse-image lookups.
   Scoped to images ONLY. See _dv_image_protect_deploy.py for what this does
   and does not achieve. */
(function () {
  'use strict';

  /* Behavioural CSS is injected from here rather than living in dv-custom.css
     so the whole feature is one asset and one <head> line. These properties are
     invisible, so injecting them late cannot cause a flash of unstyled content. */
  var css = document.createElement('style');
  css.textContent =
    'img,picture{-webkit-touch-callout:none;-webkit-user-drag:none;' +
    '-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none;}';
  (document.head || document.documentElement).appendChild(css);

  function isImage(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toLowerCase();
    if (tag === 'img' || tag === 'picture' || tag === 'source') return true;
    /* Some sections paint the photo as a background on a wrapper instead of
       using <img>. Walk up a couple of levels rather than querying theme class
       names, which differ per section and would silently miss cases. */
    var node = el, hops = 0;
    while (node && hops < 3) {
      if (node.querySelector && node.matches && node.matches('picture')) return true;
      node = node.parentElement;
      hops++;
    }
    return false;
  }

  /* Capture phase: run before any theme/app handler can stop propagation. */
  document.addEventListener('contextmenu', function (e) {
    if (isImage(e.target)) e.preventDefault();
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (isImage(e.target)) e.preventDefault();
  }, true);

  /* draggable=false is the standard attribute equivalent of the dragstart
     block, and it also stops the browser's own drag ghost image appearing.
     Applied on load and re-applied for images added later (quick view,
     infinite scroll, cart drawer) via a MutationObserver. */
  function markImages(root) {
    var imgs = (root || document).querySelectorAll('img:not([data-dvp])');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('draggable', 'false');
      imgs[i].setAttribute('data-dvp', '1');
    }
  }

  function start() {
    markImages(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') {
            n.setAttribute('draggable', 'false');
            n.setAttribute('data-dvp', '1');
          } else {
            markImages(n);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
